import {
  Control,
  Controller,
  FieldErrors,
  UseFormWatch,
} from 'react-hook-form';
import { User } from '../../../../../../types';

import { Editor as TinyMCEEditor } from 'tinymce';
import { useRef, useState } from 'react';
import WelcomeFields from './../welcome-fields';
import TextEditor from '../../../../../shared/editor/text-editor';
import PopulateWelcomeTemplate from './../populate-welcome-template';
import { WelcomeTemplateFormValues } from '../welcome-templates-form-page';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';

interface StepWelcomeTemplateBodyProps {
  control: Control<WelcomeTemplateFormValues>;
  errors: FieldErrors<WelcomeTemplateFormValues>;
  watch: UseFormWatch<WelcomeTemplateFormValues>;
  user: User | undefined;
  disabled?: boolean;
}

export default function StepWelcomeTemplateBody({
  control,
  errors,
  user,
  watch,
  disabled,
}: StepWelcomeTemplateBodyProps) {
  const editorRef = useRef<TinyMCEEditor | null>(null);
  const [body, setBody] = useState(watch('templateHtml') || '');

  return (
    <Stack
      sx={{
        viewTransitionName: 'steps',
        flex: 1,
      }}
      gap={2}
    >
      <Typography>
        Please provide the email body content for your welcome template. You can
        use the rich text editor to personalize the message.
      </Typography>
      <Stack alignItems="flex-start" sx={{ flex: 1 }}>
        <Stack flexDirection="column" sx={{ width: '100%', height: '100%' }}>
          <Stack mt={-1}>
            <WelcomeFields editorRef={editorRef} disabled={disabled} />
          </Stack>
          <Stack flexDirection="row" gap={2} sx={{ width: '100%', flex: 1 }}>
            <Box
              sx={{
                flex: '1 1 50%',
                display: 'flex',
                flexDirection: 'column',
                ...(errors.templateHtml && {
                  border: (theme) => `1px solid ${theme.palette.error.main}`,
                  borderRadius: 3,
                  height: 'calc(100% - 20px)',
                }),
              }}
            >
              <Controller
                name="templateHtml"
                control={control}
                render={({ field }) => (
                  <Box sx={{ flex: 1 }}>
                    <TextEditor
                      content={field.value!}
                      editorRef={editorRef}
                      disabled={disabled}
                      setContent={(newContent) => {
                        field.onChange(newContent);
                        setBody(newContent);
                      }}
                    />
                    <FormHelperText
                      error={!!errors.templateHtml}
                      sx={{
                        mt: 1,
                        ml: 0,
                        display: errors.templateHtml ? 'block' : 'none',
                      }}
                    >
                      {errors?.templateHtml?.message || ' '}
                    </FormHelperText>
                  </Box>
                )}
              />
            </Box>
            <Box
              sx={{
                flex: '1 1 50%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <PopulateWelcomeTemplate
                user={user}
                template={body}
                height="100%"
              />
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
